module.exports = __webpack_public_path__ + "static/media/img-2.d22e88d8.jpg";